<template>
  <b-card>
    <title-name />
    <symbol-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Currencies/elements/Title.vue'
import SymbolName from '@/views/Admin/Defines/Currencies/elements/Symbol.vue'

export default {
  name: 'CurrencyForm',
  components: {
    BCard,
    TitleName,
    SymbolName,
  },
}
</script>
